var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.9957C27.9999 11.3206 27.233 8.70151 25.79 6.44867C24.3471 4.19583 22.2885 2.4036 19.8582 1.28423C17.4278 0.16485 14.7275 -0.234778 12.077 0.13267C9.42647 0.500119 6.93682 1.61925 4.90286 3.35753C2.8689 5.09581 1.37586 7.38041 0.60054 9.94077C-0.174778 12.5011 -0.199886 15.23 0.528189 17.8042C1.25626 20.3784 2.70702 22.69 4.70865 24.4654C6.71028 26.2408 9.17892 27.4056 11.8222 27.8217V18.0493H8.26104V13.9957H11.816V10.9103C11.816 7.40408 13.9067 5.46537 17.1049 5.46537C18.1548 5.48005 19.2022 5.57153 20.2388 5.73907V9.18313H18.4738C16.7336 9.18313 16.1923 10.2634 16.1923 11.3686V13.9957H20.075L19.4527 18.041H16.1881V27.8217C19.4809 27.2999 22.4795 25.6209 24.6447 23.0865C26.8099 20.5521 27.9996 17.3286 28 13.9957Z",
    fill: "#4676ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4487 18.0494L20.0709 14.0041H16.1883V11.3687C16.1883 10.2635 16.7296 9.18321 18.4697 9.18321H20.2348V5.73916C19.1982 5.57162 18.1508 5.48014 17.1008 5.46545C13.9026 5.46545 11.812 7.40416 11.812 10.9104V13.9958H8.26114V18.0494H11.8161V27.8301C13.2661 28.0568 14.7424 28.0568 16.1924 27.8301V18.0494H19.4487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.a9d84c98c4b0650dd878eef6f4fa3f10.svg";
export { ForwardRef as ReactComponent };